import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/images/network_logo_minicity.png';
const _withScopeId = n => (_pushScopeId("data-v-1ed9192d"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "badge" };
const _hoisted_2 = {
    key: 0,
    class: "networkLogo mr-2",
    src: _imports_0
};
const _hoisted_3 = {
    key: 1,
    class: "fas fa-user-circle fa-lg mr-3 mt-2"
};
const _hoisted_4 = { class: "level is-mobile" };
const _hoisted_5 = { class: "adaptiveLabel" };
const _hoisted_6 = {
    key: 0,
    class: "tag is-danger is-light is-rounded has-text-weight-bold ml-1"
};
const _hoisted_7 = {
    key: 1,
    class: "tag is-info is-light is-rounded has-text-weight-bold ml-1"
};
const _hoisted_8 = {
    key: 2,
    class: "tag is-info is-light is-rounded has-text-weight-bold ml-1"
};
const _hoisted_9 = {
    key: 3,
    class: "tag is-warning is-light is-rounded has-text-weight-bold ml-1"
};
const _hoisted_10 = {
    key: 4,
    class: "tag is-warning is-light is-rounded has-text-weight-bold ml-1"
};
import { CONFIG } from "@/core/config";
import { canSeeFeature } from "@/core/session";
import { User } from "@minicity/core";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UserBadge',
    props: {
        user: {},
        disabled: { type: Boolean },
        noLink: { type: Boolean }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            var _a;
            return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.user && !_ctx.noLink && [_unref(User).Role.PARTNER_ADMIN, _unref(User).Role.PARTNER_USER].includes(_ctx.user.role) && _unref(canSeeFeature)('partnerUsers') ? 'router-link' : 'span'), {
                to: `/partnerUsers/${(_a = _ctx.user) === null || _a === void 0 ? void 0 : _a.id}`
            }, {
                default: _withCtx(() => {
                    var _a, _b, _c, _d, _e;
                    return [
                        _createElementVNode("div", _hoisted_1, [
                            (((_a = _ctx.user) === null || _a === void 0 ? void 0 : _a.role) == _unref(User).Role.NETWORK_ADMIN)
                                ? (_openBlock(), _createElementBlock("img", _hoisted_2))
                                : (_openBlock(), _createElementBlock("i", _hoisted_3)),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createTextVNode(_toDisplayString(_ctx.user ? _ctx.user.displayName : "Missing Name") + " ", 1),
                                    (_ctx.disabled)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Hidden"))
                                        : _createCommentVNode("", true),
                                    (((_b = _ctx.user) === null || _b === void 0 ? void 0 : _b.role) == _unref(User).Role.NETWORK_ADMIN)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(CONFIG).networkName) + " Team", 1))
                                        : _createCommentVNode("", true),
                                    (((_c = _ctx.user) === null || _c === void 0 ? void 0 : _c.role) == _unref(User).Role.PARTNER_ADMIN)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Admin"))
                                        : _createCommentVNode("", true),
                                    ((_d = _ctx.user) === null || _d === void 0 ? void 0 : _d.isPendingApproval)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Pending Approval"))
                                        : ((_e = _ctx.user) === null || _e === void 0 ? void 0 : _e.isPendingPortalInvite)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Pending Portal Invite"))
                                            : _createCommentVNode("", true)
                                ])
                            ])
                        ])
                    ];
                }),
                _: 1
            }, 8, ["to"]));
        };
    }
});
